<template>
  <div class="learner-profile">
    <transition name="toast">
      <toast v-if="toast" :msg="msg" />
    </transition>
    <h1>Leader's Profile</h1>
    <div class="profile-form">
      <form @submit.prevent="handleSubmit">
        <fieldset>
          <legend>About Leader</legend>
          <div class="bio flex">
            <label>{{ currentUser.state.user.displayName }}</label>
            <label>{{ currentUser.state.grade }}</label>
          </div>
          <label>
            <input
            v-model="birthday"
            type="date"
            >
            Leader's Date of Birth
          </label>
          <label>
            <input
            v-model="address"
            type="text"
            >
            Leader's Residential Address
          </label>
          <label>
            <input
            v-model="hobbies"
            type="text"
            >
            Hobbies
          </label>
        </fieldset>
        <fieldset>
          <legend>Parents/Guardians Details</legend>
          <label>
            <input
            v-model="fathersName"
            type="text"
            >
            Father's/Male Guardian's Name
          </label>
          <label>
            <input
            v-model="fathersOccupation"
            type="text"
            >
            Occupation
          </label>
          <label>
            <input
            v-model="fathersContact"
            type="text"
            >
            Father's/Male Guardian's Contact
          </label>
          <label>
            <input
            v-model="fathersEmail"
            type="text"
            >
            Email Address
          </label>
          <label>
            <input
            v-model="mothersName"
            type="text"
            >
            Mother's/Female Guardian's Name
          </label>
          <label>
            <input
            v-model="mothersOccupation"
            type="text"
            >
            Occupation
          </label>
          <label>
            <input
            v-model="mothersContact"
            type="text"
            >
            Mother's/Female Guardian's Contact
          </label>
          <label>
            <input
            v-model="mothersEmail"
            type="text"
            >
            Email Address
          </label>
        </fieldset>

        <fieldset>
          <legend>Emergency Contact</legend>
          <div class="flex">
            <h3>Name of person to be contacted in an emergency (If Parents/Guardians are unreachable)</h3>
          </div>
          <label>
            <input
            v-model="emergencyName"
            type="text"
            >
            Name
          </label>
          <label>
            <input
            v-model="emergencyContact"
            type="text"
            >
            Contact
          </label>
        </fieldset>

        <button :disabled="wait">Update</button>
      </form>
    </div>
  </div>
</template>

<script>
import { inject, ref, watchEffect } from 'vue'
import { db, serverTimestamp, setDoc, doc } from '@/firebase/config'
import getPost from '@/composables/getPost'
import Toast from '@/components/Toast.vue'

export default {
  name: 'Profile',
  components: { Toast },
  setup () {
    const toast = ref(false)
    const msg = ref('Leaders Profile Updated')
    const wait = ref(false)
    const birthday = ref(null)
    const address = ref('')
    const hobbies = ref('')
    const fathersName = ref('')
    const mothersName = ref('')
    const fathersOccupation = ref('')
    const mothersOccupation = ref('')
    const fathersContact = ref('')
    const mothersContact = ref('')
    const fathersEmail = ref('')
    const mothersEmail = ref('')
    const emergencyName = ref('')
    const emergencyContact = ref('')
    const currentUser = inject('currentUser')
    const { myData, error, load } = getPost()

    load(currentUser.state.user.uid, 'records')

    const handleSubmit = async () => {
      wait.value = true

      const data = {
        birthday: birthday.value,
        address: address.value,
        hobbies: hobbies.value,
        fathersName: fathersName.value,
        mothersName: mothersName.value,
        fathersOccupation: fathersOccupation.value,
        mothersOccupation: mothersOccupation.value,
        fathersContact: fathersContact.value,
        mothersContact: mothersContact.value,
        fathersEmail: fathersEmail.value,
        mothersEmail: mothersEmail.value,
        emergencyName: emergencyName.value,
        emergencyContact: emergencyContact.value,
        createdAt: serverTimestamp()
      }

      await setDoc(doc(db, 'schools/inspire-schools/records', currentUser.state.user.uid), data, { merge: true })
      triggerToast()
      wait.value = false
    }

    const triggerToast = () => {
      toast.value = true
      setTimeout(() => {
        toast.value = false
      }, 3000)
    }

    watchEffect(() => {
      birthday.value = myData.value ? myData.value.birthday : null
      address.value = myData.value ? myData.value.address : null
      hobbies.value = myData.value ? myData.value.hobbies : null
      fathersName.value = myData.value ? myData.value.fathersName : null
      mothersName.value = myData.value ? myData.value.mothersName : null
      fathersOccupation.value = myData.value ? myData.value.fathersOccupation : null
      mothersOccupation.value = myData.value ? myData.value.mothersOccupation : null
      fathersContact.value = myData.value ? myData.value.fathersContact : null
      mothersContact.value = myData.value ? myData.value.mothersContact : null
      fathersEmail.value = myData.value ? myData.value.fathersEmail : null
      mothersEmail.value = myData.value ? myData.value.mothersEmail : null
      emergencyName.value = myData.value ? myData.value.emergencyName : null
      emergencyContact.value = myData.value ? myData.value.emergencyContact : null
    })

    return { myData, error, handleSubmit, currentUser, msg, toast, wait, birthday, address, hobbies, fathersName, fathersOccupation, fathersContact, fathersEmail, mothersName, mothersOccupation, mothersContact, mothersEmail, emergencyName, emergencyContact }
  }
}
</script>

<style>
  .learner-profile {
    background-color: var(--sidebar-item-active);
    min-height: 100vh;
    overflow: hidden;
    width: 100%;
  }
  .learner-profile form fieldset {
    color: #fff;
    padding: 10px;
    border-radius: 20px;
    border: 1px solid yellow;
  }
  .learner-profile form {
    max-width: 920px;
    margin: 5px auto;
    padding: 4px;
    /* background-color: #b54f9df0; */
    background-color: #FF54ACB0;
  }
  .learner-profile .bio {
    font-size: 1.5em;
    justify-content: space-between;
  }
  .learner-profile label {
    display: block;
    color: var(--inspire-gold);
  }
  .learner-profile input {
    outline: none;
    background: none;
    border: 1px solid #00000009;
    font-size: 1.6em;
    padding: .5em;
    color: inherit;
    border-radius: 5px;
    text-transform: uppercase;
    }

    .learner-profile input:focus {
    border-color: var(--sidebar-item-hover);
    }
</style>
